import NaptimeResource from './NaptimeResource';

class OnDemandLearnerMaterialWeeks extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandLearnerMaterialWeeks.v1';

  declare totalPassablesCount: number;
}

export default OnDemandLearnerMaterialWeeks;
